<template>
  <teleport to="body">
    <div class="modal fade show" tabindex="-1" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs">Session About to Expire</p>
          <button
            type="button"
            class="modal-btn-close btn-close"
            @click="on_logout"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p class="text-xs">
            Your session will expire due to inactivity in
            <span class="fw-bold">{{ seconds_left }}</span> seconds.
          </p>
          <p class="text-xs">Would you like to continue working?</p>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm me-2"
            @click="on_continue"
          >
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  </div>
  </teleport>
  
</template>
<script>
export default {
  name: "SessionTimeoutModal",
  props: {
    seconds_left: {
      type: Number,
      required: true,
    },
    on_continue: {
      type: Function,
      required: true,
    },
  },
};
</script>
